import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';

import { MegaMenuNavItem } from './types';

const {
  PRIMARY: { WEBSITE },
} = NAV_DATA;

const getWebsite = (): MegaMenuNavItem => {
  const exploreChildren = [
    {
      title: "Find A Couple's Website",
      path: '/search/wedding-registry',
    },
    {
      title: 'About Zola Websites',
      path: '/wedding-planning/website',
    },
    {
      title: 'How Online RSVP Works',
      path: '/faq/category/115000342412-wedding-website/115000582491-rsvp',
    },
    {
      title: 'Website Expert Advice',
      path: '/expert-advice/topic/invites-paper/website-invites',
    },
    {
      title: 'Website FAQs',
      path: '/faq/category/115000342412-wedding-website',
    },
  ];

  return {
    title: 'Website',
    id: WEBSITE,
    path: '/wedding-planning/website',
    parent: 'Website', // a bit weird
    callToAction: {
      path: '/wedding-planning/website/designs',
      title: 'Start Your Website',
      items: [
        'Hundreds of gorgeous designs for every style',
        'Quick and easy to customize (just 5 minutes!)',
        'Wedding details, registry, and RSVP in one place',
      ],
    },
    userActionsLinks: [
      {
        title: 'Manage Website',
        path: '/wedding/manage/website/manage',
      },
      {
        title: 'Change Your Design',
        path: '/wedding/manage/website/designs',
      },
    ],
    children: [
      {
        headline: 'Explore Zola Websites',
        borderLeft: true,
        children: exploreChildren,
      },
    ],
  };
};

export default getWebsite;
